import React from "react";

const Loader = ({ hidden }) => {
  if (hidden) return null;
  return <div>Loading...</div>; // Simple loader component
};

export default Loader;
